/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useMemo, useRef, useState} from 'react'
import {useIntl} from 'react-intl'
import {useAuth} from '../../auth'
import {
  copyToClipboard,
  formatBillingPeriod,
  toTitleCase,
  getFormattedDate,
  removeNullFields,
} from '../../../core/_util'
import useChargebeeScript from '../../../hooks/useChargebeeScript'
import {
  getBillingAccess,
  getAllInvoices,
  getInvoiceDownloadUrl,
  disconnectNylas,
  getMailInfo,
  accessPortalForUpdatePlan,
  payDuePayments,
} from '../core/_requests'
import warningIcon from '../../../../media/billing/ic-warning.svg'
import visaCard from '../../../../media/billing/ic-visa-card.svg'
import masterCard from '../../../../media/billing/ic-master-card.svg'
import americanExpressCard from '../../../../media/billing/ic-ae-card.svg'
import RupayCard from '../../../../media/billing/ic-rupay-card.svg'
import maestroCard from '../../../../media/billing/ic-maestro-card.svg'
import eMandateLogo from '../../../../media/billing/ic-e-mandate.svg'
import upiLogo from '../../../../media/billing/ic-upi.svg'
import otherPaymentMethodLogo from '../../../../media/billing/ic-others.svg'
import noPaymentMethodLogo from '../../../../media/billing/ic-others-disabled.svg'
import LockecIcon from '../../../../media/billing/ic-locked.svg'
import Downloadicon from '../../../../media/billing/ic-download.svg'
import IcCopy from '../../../../media/billing/ic-copy.svg'
import {Form, Pagination, Table, Modal, Button, Dropdown} from 'react-bootstrap'
import '../styles/billing.scss'
import Skeleton from 'react-loading-skeleton'
import {toast} from 'react-toastify'
import threeDots from '../../../../_metronic/assets/images/svg/investor/threeDots.svg'
import useGetBillingData from '../../../../app/hooks/useGetBillingData'
import {NoDataPage} from '../../resources/components/NoDataPage'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'
import brandingConfig from '../../../../config/brandingConfig'
import BillingModalRK from '../../onboarding/views/BillingModalRK'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {getUserByToken, refreshTokenApi} from '../../auth/core/_requests'

declare var Chargebee: any

export function Billing({
  key,
  billingData,
  selected,
  setSelected,
  onAccessBillingPortal,
  getBillingDetails,
  loading,
  setLoading,
}: {
  key: number
  billingData: any
  selected: string
  setSelected: any
  onAccessBillingPortal: any
  getBillingDetails: any
  loading: boolean
  setLoading: any
}) {
  const {formatMessage} = useIntl()
  const {
    setBillingData,
    companyId,
    currentUser,
    setEntitlements,
    currencyBill,
    setInvoiceStatus,
    setPlanStatus,
    saveAuth,
    setUserToken,
    setCompanyQueuePosition,
    setUseCase,
  } = useAuth()
  const cbInstance = useChargebeeScript()
  const [showUpdateAddressInfoModal, setShowUpdateAddressInfoModal] = useState(false)
  const [downloadingStatus, setDownloadingStatus] = useState<{[key: string]: boolean}>({})
  const [invoices, setInvoices] = useState([])
  const {getBillingDetailsAPI} = useGetBillingData(companyId!)
  // const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [searchQuery, setSearchQuery] = useState('')
  const [currentState, setCurrentState] = useState<string>('Monthly')
  // const [currencyBill, setCurrencyBill] = useState('USD') //eslint-disable-line
  const [urlData, setUrlData] = useState('')
  const [showIframeModal, setShowIframeModal] = useState(false)
  const [isActive, setIsActive] = useState(false)
  // const [isNewActive, setIsNewActive] = useState(false)
  const [localBilling, setlocalBilling] = useState<string>('Monthly')
  const [localPlan, setlocalPlan] = useState<any | undefined>('Basic')
  const [billingModalLoading, setBillingModalLoading] = useState(false)
  const params = new URLSearchParams(window.location.search)
  const id = params.get('id')
  const state = params.get('state')
  const oldBillingPlan = localStorage.getItem('oldBillingPlan')
  const hasRun = useRef(false)

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const response = await getAllInvoices(companyId)
        if (response.data.success) {
          const mappedInvoices = response.data.data.map((invoice: any, index: number) => ({
            id: index + 1,
            billingDate: getFormattedDate(invoice.invoice.generated_at),
            invoiceId: invoice.invoice.id,
            currency: invoice.invoice.currency_code,
            amount:
              invoice.invoice.amount_due > 0
                ? invoice.invoice.amount_due / 100
                : invoice.invoice.amount_paid / 100,
            status: invoice.invoice.status,
            statusBadge: getStatusBadge(invoice.invoice.status),
          }))
          setInvoices(mappedInvoices)
        } else {
          console.log('Failed to fetch invoices')
        }
      } catch (err) {
        console.error('Error fetching invoices:', err)
      }
    }

    if (companyId) {
      fetchInvoices()
    }
  }, [companyId])

  useEffect(() => {
    getBillingDetails()
  }, [key]) // eslint-disable-line react-hooks/exhaustive-deps

  // Helper function to determine the badge color based on the invoice status
  const getStatusBadge = (status: string) => {
    switch (status?.toLowerCase()) {
      case 'paid':
        return 'success'
      case 'not_paid':
        return 'danger'
      default:
        return 'warning'
    }
  }

  // useEffect(() => {
  //   if (billingData?.base_currency_code) {
  //     setCurrencyBill(billingData?.currency_code)
  //   }
  //   if (billingData?.billing_period_unit) {
  //     setCurrentState(`${billingData?.billing_period_unit}ly`)
  //   }
  // }, [billingData, billingData?.base_currency_code, billingData?.billing_period_unit])

  // useEffect(() => {
  //   setBillingLoading(true)
  //   setLoading(true)
  //   if (billingData?.customer?.billing_address) {
  //     const timeout = setTimeout(() => {
  //       setBillingLoading(false)
  //       setLoading(false)
  //     }, 500)
  //     return () => clearTimeout(timeout)
  //   } else if (billingData) {
  //     setLoading(false)
  //     setBillingLoading(false)
  //   }
  // }, [billingData, billingData?.customer?.billing_address])
  // console.log(loading,' loading')
  // useEffect(() => {
  //   setLoading(true)
  //   console.log(loading, ' hi1')

  //   if (
  //     billingData &&
  //     ((billingData?.customer && billingData?.customer?.billing_address) ||
  //       billingData?.customer_id)
  //   ) {
  //     setLoading(false)
  //     console.log(loading, ' h2')
  //   }
  // }, [billingData, billingData?.customer, billingData?.customer?.billing_address])

  const openPortalSection = async (sectionType: string, subscriptionId?: string) => {
    setLoading(true)
    setBillingModalLoading(true)
    if (!cbInstance) {
      console.error('Chargebee is not loaded yet')
      return
    }

    cbInstance.setPortalSession(async () => {
      try {
        const response = await getBillingAccess(companyId)
        return response.data.data
      } catch (error) {
        console.error('Error creating portal session:', error)
        throw error
      } finally {
      }
    })

    const cbPortal = cbInstance.createChargebeePortal()
    let params: any = null
    if (subscriptionId) {
      params = {
        subscriptionId,
      }
    }
    setIsActive(false)
    setBillingModalLoading(false)
    cbPortal.openSection(
      {
        sectionType,
        params,
      },
      {
        loaded: async () => {
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ChargebeePortalWidgetOpened,
              metadata: removeNullFields({
                section_type: sectionType,
                params,
                company: {
                  company_id: companyId,
                },
              }),
            },
          })
        },
        close: async () => {
          const result = await getBillingDetailsAPI()
          const newBillingData = {
            ...result.output,
            ...result.customer_info,
            renewal_estimate: result.renewal_estimate,
            company_country: result.company_country,
          }
          if (result?.output?.subscription_items[0].item_price_id.split('-')[0] === 'Basic') {
            getMailInformation()
          }
          fireAnalyticEvents(sectionType, billingData, newBillingData)

          setBillingData(newBillingData)
          setEntitlements(result.entitlement_list as any[])
          setLoading(false)
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ChargebeePortalWidgetClosed,
              metadata: {
                section_type: sectionType,
                params,
                company_id: companyId,
              },
            },
          })
        },
      }
    )

    /* NOTE: Uncomment this to use Chargebee protal with specific section open instead of portal widgets
    var callbacks = {};
    cbPortal.open(callbacks,
      {
        sectionType: Chargebee.getPortalSections().EDIT_SUBSCRIPTION,
        params: {
          subscriptionId: "sub id"
        }
      }
    );
    */
  }

  const getPaymentMethodTypeLogo = (paymentMethodType: string) => {
    switch (paymentMethodType) {
      case 'visa':
        return visaCard
      case 'mastercard':
        return masterCard
      case 'american_express':
        return americanExpressCard
      case 'rupay':
        return RupayCard
      case 'maestro':
        return maestroCard
      case 'upi':
        return upiLogo
      case 'netbanking_emandates':
        return eMandateLogo
      case undefined:
      case null:
        return noPaymentMethodLogo
      default:
        return otherPaymentMethodLogo
    }
  }

  const downloadInvoice = async (invoiceId: string) => {
    try {
      setDownloadingStatus((prev) => ({...prev, [invoiceId]: true}))

      const {
        data: {success, data, errors},
      } = await getInvoiceDownloadUrl(invoiceId)

      if (success) {
        if (data.download_url) {
          // Download file
          const response = await fetch(data.download_url)
          const blob = await response.blob()

          // Create a download link
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${invoiceId}.pdf`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.BillingInvoiceDownloadedSuccessful,
              metadata: {
                invoice_id: invoiceId,
                downloaded_by_user_id: currentUser?.userId,
                company_id: companyId,
              },
            },
          })
        }
      } else {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.BillingInvoiceDownloadedFailed,
            metadata: {
              invoice_id: invoiceId,
              downloaded_by_user_id: currentUser?.userId,
              company_id: companyId,
            },
          },
        })

        errors?.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (err) {
      console.log(err)
    } finally {
      setDownloadingStatus((prev) => ({...prev, [invoiceId]: false}))
    }
  }

  const showPaymentPortalWidget = () => {
    if (billingData?.customer?.billing_address?.country !== undefined) {
      openPortalSection(Chargebee.getPortalSections().PAYMENT_SOURCES)
    } else {
      // Show modal if country is not defined i.e no address
      setShowUpdateAddressInfoModal(true)
    }
  }

  const handleShowUpdateAddressInfoModal = () => {
    // Close the modal
    setShowUpdateAddressInfoModal(false)
    // Open the address portal section
    openPortalSection(Chargebee.getPortalSections().ADDRESS)
  }

  // analytics
  const fireAnalyticEvents = (sectionType: string, oldBillingData: any, newBillingData: any) => {
    switch (sectionType) {
      case Chargebee.getPortalSections().ADDRESS:
        if (
          hasAddressChanged(
            oldBillingData?.customer?.billing_address,
            newBillingData?.customer?.billing_address
          )
        ) {
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.BillingAddressChangedSuccessful,
              metadata: {
                ...newBillingData.customer.billing_address,
                company_id: companyId,
              },
            },
          })
        }
        return
      case Chargebee.getPortalSections().PAYMENT_SOURCES:
        if (hasPaymentMethodChanged(oldBillingData, newBillingData)) {
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.PaymentMethodChangedSuccessful,
              metadata: {
                payment_method_type: newBillingData.customer?.payment_method?.type,
                card_type: newBillingData.card?.card_type,
                card_last4_digit: newBillingData.card?.last4,
                status: newBillingData.card?.status,
                company_id: companyId,
              },
            },
          })
        }
        return
      case Chargebee.getPortalSections().SUBSCRIPTION_DETAILS:
        const oldPlanDetails = extractPlanDetails(oldBillingData)
        const newPlanDetails = extractPlanDetails(newBillingData)
        if (oldPlanDetails?.item_price_id !== newPlanDetails?.item_price_id) {
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.CompanyPlanChangedSuccessful,
              metadata: removeNullFields({
                old_plan: oldPlanDetails?.item_price_id,
                new_plan: newPlanDetails?.item_price_id,
                new_plan_amount: newPlanDetails?.amount / 100,
                currency: newBillingData?.currency_code,
                company_id: companyId,
              }),
            },
          })
          if (newPlanDetails && oldPlanDetails && newPlanDetails.amount > oldPlanDetails.amount) {
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.SubscriptionUpgraded,
                metadata: {
                  company_id: companyId,
                  currency: newBillingData?.currency_code,
                  value: newPlanDetails?.amount / 100,
                  frequency: `${newBillingData?.billing_period_unit}ly`,
                  old_currency: oldBillingData?.currency_code,
                  old_value: oldPlanDetails?.amount / 100,
                  old_frequency: `${oldBillingData?.billing_period_unit}ly`,
                },
              },
            })
          } else if (
            newPlanDetails &&
            oldPlanDetails &&
            newPlanDetails.amount < oldPlanDetails.amount
          ) {
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.SubscriptionDowngraded,
                metadata: {
                  company_id: companyId,
                  currency: newBillingData?.currency_code,
                  value: newPlanDetails?.amount / 100,
                  frequency: `${newBillingData?.billing_period_unit}ly`,
                  old_currency: oldBillingData?.currency_code,
                  old_value: oldPlanDetails?.amount / 100,
                  old_frequency: `${oldBillingData?.billing_period_unit}ly`,
                },
              },
            })
          }
        }
    }
  }

  // Function to extract item_price_id and amount for the first item where item_type is 'plan'
  function extractPlanDetails(billingData: any) {
    for (const item of billingData.subscription_items) {
      if (item.item_type === 'plan') {
        return {
          item_price_id: item.item_price_id,
          amount: item.amount,
        }
      }
    }
    return null // Return null if no plan type item is found
  }

  function hasAddressChanged(oldAddress: any, newAddress: any) {
    if (!oldAddress) oldAddress = {}
    if (!newAddress) newAddress = {}
    const keys = [
      'first_name',
      'last_name',
      'line1',
      'line2',
      'city',
      'state_code',
      'state',
      'country',
      'zip',
    ]

    // Check if any of the values differ
    for (const key of keys) {
      if (oldAddress[key] !== newAddress[key]) {
        return true // Return true if there's any difference
      }
    }

    return false // all values are the same
  }

  function hasPaymentMethodChanged(oldBillingData: any, newBillingData: any) {
    if (
      oldBillingData.customer?.payment_method?.type !==
        newBillingData.customer?.payment_method?.type ||
      oldBillingData.card?.card_type !== newBillingData.card?.card_type ||
      oldBillingData.card?.last4 !== newBillingData.card?.last4
    ) {
      return true
    }

    return false
  }

  //pagination

  // Change page handler
  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber)
  }

  // Change items per page handler
  const handleItemsPerPageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setItemsPerPage(Number(e.target.value))
    setCurrentPage(1) // Reset to first page when changing items per page
  }

  // Pagination component rendering
  const pageCount = Math.ceil(invoices.length / itemsPerPage)
  const pages = []
  for (let i = 1; i <= pageCount; i++) {
    pages.push(
      <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
        {i}
      </Pagination.Item>
    )
  }

  // Search Logic here
  const handleSearchChange = (event: any) => {
    setSearchQuery(event.target.value)
    setCurrentPage(1) // Reset to first page on search
  }

  // Filtered invoices based on search query
  const filteredInvoices = useMemo(() => {
    return invoices.filter(
      (invoice: {invoiceId: String; billingDate: String; status: String}) =>
        invoice?.invoiceId.toLowerCase().includes(searchQuery.toLowerCase()) ||
        invoice?.billingDate.toLowerCase().includes(searchQuery.toLowerCase()) ||
        invoice?.status.toLowerCase().includes(searchQuery.toLowerCase())
    )
  }, [invoices, searchQuery])

  const paginatedInvoices = useMemo(
    () => filteredInvoices.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage),
    [filteredInvoices, currentPage, itemsPerPage]
  )

  const handleConfirmDisconnect = async () => {
    try {
      const isNylasActive = 'disconnect'
      const {
        data: {data, success, errors}, // eslint-disable-line
      } = await disconnectNylas(isNylasActive, companyId)
      if (success) {
        console.log('Downgraded')
      } else {
        toast.error(errors[0])
      }
    } catch (error) {
      toast.error(formatMessage({id: 'Something went wrong while disconnecting your account.'}))
    } finally {
    }
  }

  // useEffect(() => {
  //   if (billingData?.subscription_items[0].item_price_id.split('-')[0] === 'Basic') {
  //     handleConfirmDisconnect()
  //   }
  // }, [billingData]) // eslint-disable-line react-hooks/exhaustive-deps

  const refreshToken = async (itemCompany: number) => {
    try {
      const {
        data: {success, data},
      } = await refreshTokenApi()

      if (success) {
        await saveAuth(data)
        setUserToken(data.token)

        setInvoiceStatus(data?.companyPlanStatus?.invoiceStatus)
        setPlanStatus(data?.companyPlanStatus?.planStatus)

        const {data: userData} = await getUserByToken(data.token)
        if (userData?.data) {
          const findCompany = userData?.data?.company?.find(
            (company: {companyId: number}) => company.companyId === itemCompany
          )
          if (findCompany) {
            setCompanyQueuePosition(findCompany?.queuePosition)
            setUseCase(findCompany?.useCase)
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (billingData) {
      setCurrentState(billingData?.subscription_items[0].item_price_id.split('-')[2])
      setSelected(billingData?.subscription_items[0].item_price_id.split('-')[0])
      setlocalPlan(billingData?.subscription_items[0].item_price_id.split('-')[0])
      setlocalBilling(
        billingData?.billing_period_unit === 'year'
          ? 'Yearly'
          : billingData?.billing_period_unit === 'month'
          ? 'Monthly'
          : 'Monthly'
      )
      refreshToken(+companyId!)
    }
  }, [billingData]) // eslint-disable-line react-hooks/exhaustive-deps

  const getMailInformation = async () => {
    try {
      const {
        data: {success, data, errors},
      } = await getMailInfo(companyId)
      if (success) {
        if (data.nylasGoogle || data.nylasMicrosoft) {
          handleConfirmDisconnect()
        }
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }
  useEffect(() => {
    const oldPlan = oldBillingPlan ? JSON.parse(oldBillingPlan) : null
    if (id && state && oldPlan && billingData && !hasRun.current) {
      hasRun.current = true
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.ChargebeePortalWidgetClosed,
          metadata: {
            company_id: companyId,
          },
        },
      })
      if (oldPlan?.item_price_id !== billingData?.subscription_items[0].item_price_id) {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.CompanyPlanChangedSuccessful,
            metadata: removeNullFields({
              company: {
                old_plan: oldPlan?.item_price_id,
                old_plan_transaction_id: oldPlan?.transaction_id,
                new_plan: billingData?.subscription_items[0].item_price_id,
                new_plan_amount: billingData?.subscription_items[0]?.amount / 100,
                currency: billingData?.currency_code,
                company_id: companyId,
                new_plan_transaction_id: billingData?.transaction_id,
              },
            }),
          },
        })
        if (billingData?.subscription_items[0].amount > oldPlan?.amount) {
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.SubscriptionUpgraded,
              metadata: {
                company: {
                  company_id: companyId,
                  plan: billingData?.subscription_items[0].item_price_id,
                  currency: billingData?.currency_code,
                  value: billingData?.subscription_items[0]?.amount / 100,
                  value_in_cents: billingData?.subscription_items[0]?.amount,
                  frequency: `${billingData?.billing_period_unit}ly`,
                  transaction_id: billingData?.transaction_id,
                  old_plan: oldPlan?.item_price_id,
                  old_currency: oldPlan?.currency_code,
                  old_value: oldPlan?.amount / 100,
                  old_value_in_cents: oldPlan?.amount,
                  old_frequency: `${oldPlan?.billing_period_unit}ly`,
                  old_transaction_id: oldPlan?.transaction_id,
                },
              },
            },
          })
        } else if (billingData?.subscription_items[0].amount < oldPlan?.amount) {
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.SubscriptionDowngraded,
              metadata: {
                company: {
                  company_id: companyId,
                  plan: billingData?.subscription_items[0].item_price_id,
                  currency: billingData?.currency_code,
                  value: billingData?.subscription_items[0]?.amount / 100,
                  value_in_cents: billingData?.subscription_items[0]?.amount,
                  frequency: `${billingData?.billing_period_unit}ly`,
                  transaction_id: billingData?.transaction_id,
                  old_plan: oldPlan?.item_price_id,
                  old_currency: oldPlan?.currency_code,
                  old_value: oldPlan?.amount / 100,
                  old_value_in_cents: oldPlan?.amount,
                  old_frequency: `${oldPlan?.billing_period_unit}ly`,
                  old_transaction_id: oldPlan?.transaction_id,
                },
              },
            },
          })
        }
      }
    }
  }, [id, state, billingData]) // eslint-disable-line react-hooks/exhaustive-deps

  const getPortalLink = async (plan: string, planCurrency: string) => {
    setBillingModalLoading(true)
    try {
      const payload: any = {
        chargebeePlanId: `${plan}-${planCurrency}-${localBilling}`,
        currency: planCurrency,
        redirectUrl: window.location.href,
      }
      setLoading(true)
      const {
        data: {data, success, errors},
      } = await accessPortalForUpdatePlan(companyId!, payload)
      if (success) {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.ChargebeePortalWidgetOpened,
            metadata: removeNullFields({
              company: {
                company_id: companyId,
              },
            }),
          },
        })
        localStorage.setItem(
          'oldBillingPlan',
          JSON.stringify({
            item_price_id: billingData?.subscription_items[0].item_price_id,
            amount: billingData?.subscription_items[0].amount,
            currency_code: billingData?.currency_code,
            billing_period_unit: billingData?.billing_period_unit,
            transaction_id: billingData?.transaction_id,
          })
        )
        setIsActive(false)
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.UpgradeModalClosed,
            metadata: {
              company_id: companyId,
              page_url: `${window.location.origin}/${window.location.pathname}?tab=billing`,
            },
          },
        })
        setUrlData(data)
        setBillingModalLoading(false)
        setShowIframeModal(true)
      } else {
        errors.forEach((error: string) => {
          if (error === 'currency_mismatched') {
            toast.error(
              "Operation cannot be performed as currency (USD) of the new plan item_price 'Silver-USD-Monthly' is different from the expected value 'INR'. Please change company country from company settings."
            )
          } else {
            toast.error(formatMessage({id: error}))
          }
        })
      }
    } catch (err) {
      console.log(err)
    } finally {
      setBillingModalLoading(false)
      setLoading(false)
    }
  }
  const changePlan = (plan: string) => {
    // getPortalLink(plan, billingData?.company_country?.currency)
    getPortalLink(plan, 'USD')
  }
  const [isLoading, setIsLoading] = useState(false)
  async function collectDuePayments() {
    if (!companyId) {
      return
    }
    setIsLoading(true)
    try {
      const payload = {
        currency: 'USD',
        redirectUrl: window.location.href,
        // redirectUrl: 'https://app.recordskeeper.ai',
      }
      const {
        data: {success, data},
      } = await payDuePayments(+companyId!, payload)
      if (success) {
        window.open(data, '_blank')
      }
    } catch (error) {
      console.error('Error fetching quotas:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <div>
        {/* top Warning label  */}
        {billingData?.status === 'in_trial' &&
          !billingData?.customer?.payment_method &&
          billingData?.customer?.payment_method?.status !== 'valid' && (
            <div className='alert alert-warning d-flex w-100 align-items-center gap-2 p-4 rounded-2 mt-4'>
              <img src={warningIcon} alt='warning' />
              <div>
                <h4 className='font-size-16 m-0 mb-2'>
                  {formatMessage({id: 'We need your attention!'})}
                </h4>
                <p className='font-size-13 m-0 text-dark'>
                  {formatMessage({
                    id: `Your Free Trial is about to end. To continue using ${brandingConfig.brandName}, please`,
                  })}
                  <button
                    className='border-0 bg-transparent text-primary font-size-13'
                    onClick={showPaymentPortalWidget}
                  >
                    {formatMessage({id: 'Add Payment Method'})}
                  </button>
                </p>
              </div>
            </div>
          )}

        {/* Plan Details  */}
        <div className=' w-100'>
          <h2 className='font-size-16 m-0'>{formatMessage({id: 'Current Plan'})}</h2>
          <div className='w-100 mt-4 bg-white p-4 rounded-2'>
            <div className='row gx-6 justify-content-between mb-4'>
              <div className='col-lg-4 col-md-12 mb-4 col-sm-6'>
                <p className='font-size-14 mb-0'>
                  {loading ? (
                    <Skeleton
                      count={1}
                      height={24}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  ) : (
                    formatMessage({
                      id: `${selected} (${toTitleCase(billingData?.status || '')})`,
                    })
                  )}
                </p>
                <p className='text-muted font-size-12 mb-0'>{formatMessage({id: 'Plan Name'})}</p>
              </div>
              <div className='col-lg-4 col-md-6 mb-4 col-sm-6'>
                <p className='font-size-14 mb-0'>
                  {loading ? (
                    <Skeleton
                      count={1}
                      height={24}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  ) : (
                    formatMessage({
                      id: formatBillingPeriod(
                        billingData?.billing_period,
                        billingData?.billing_period_unit
                      ),
                    })
                  )}
                </p>
                <p className='text-muted font-size-12 mb-0'>
                  {formatMessage({id: 'Billing Cycle'})}
                </p>
              </div>
              <div className='col-lg-4 col-md-6 mb-4 col-sm-6'>
                <p className='font-size-14 mb-0'>
                  {/* {loading ? (<Skeleton count={1} height={24} baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'/>) : 
                      ({billingData?.currency_code}{' '}
                        {billingData?.subscription_items[0].amount > 0
                          ? (billingData?.subscription_items[0].amount / 100)?.toFixed(2)
                          : billingData?.subscription_items[0].amount?.toFixed(2)})
                  }*/}

                  {loading ? (
                    <Skeleton
                      count={1}
                      height={24}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  ) : billingData?.currency_code && billingData?.subscription_items.length > 0 ? (
                    <>
                      {billingData.currency_code}{' '}
                      {billingData.subscription_items[0].amount > 0
                        ? (billingData.subscription_items[0].amount / 100).toFixed(2)
                        : billingData.subscription_items[0].amount.toFixed(2)}
                    </>
                  ) : (
                    formatMessage({id: 'No billing data available'})
                  )}
                </p>
                <p className='text-muted font-size-12 mb-0'>{formatMessage({id: 'Plan price'})}</p>
              </div>
            </div>

            <div className='row gx-6 justify-content-between mb-4'>
              <div className='col-lg-4 col-md-6 col-sm-6 mb-4'>
                <p className='font-size-14 mb-0'>
                  {loading ? (
                    <Skeleton
                      count={1}
                      height={24}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  ) : billingData?.next_billing_at ? (
                    formatMessage({
                      id: new Date(billingData?.next_billing_at * 1000).toDateString(),
                    })
                  ) : (
                    formatMessage({id: 'NA'})
                  )}
                </p>
                <p className='text-muted font-size-12 mb-0'>
                  {formatMessage({id: 'Next Billing Date'})}
                </p>
              </div>
              <div className='col-lg-4 col-md-6 mb-4 col-sm-6'>
                <p className='font-size-14 mb-0'>
                  {/* {loading ? (<Skeleton count={1} height={24} baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'/>) :
                      ({ billingData?.currency_code}{' '}
                        {billingData?.renewal_estimate?.invoice_estimate?.total >= 0? 
                         (billingData?.renewal_estimate?.invoice_estimate?.total/100)?.toFixed(2)
                         : <></>
                        })
                      } */}
                  {loading ? (
                    <Skeleton
                      count={1}
                      height={24}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  ) : (
                    <>
                      {billingData?.renewal_estimate?.invoice_estimate?.total >= 0 ? (
                        <>
                          {billingData?.currency_code}{' '}
                          {(billingData.renewal_estimate.invoice_estimate.total / 100).toFixed(2)}
                        </>
                      ) : (
                        <>NA</>
                      )}
                    </>
                  )}
                </p>
                <p className='text-muted font-size-12 mb-0'>
                  {formatMessage({id: 'Next Billing Amount'})}
                </p>
              </div>
              <div className='col-lg-4 col-md-6 mb-4 col-sm-6'>
                <p className='font-size-14 mb-0'>
                  {loading ? (
                    <Skeleton
                      count={1}
                      height={24}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  ) : (
                    billingData?.id
                  )}
                  <img
                    src={IcCopy}
                    style={{cursor: 'pointer'}}
                    className={loading ? 'd-none' : 'ms-2'}
                    title='Click to copy Subscription ID'
                    alt=''
                    onClick={() =>
                      copyToClipboard(
                        billingData?.id,
                        true,
                        formatMessage({id: 'Subscription ID copied successfully'})
                      )
                    }
                  ></img>
                </p>
                <p className='text-muted font-size-12 mb-0'>
                  {formatMessage({id: 'Subscription ID'})}
                </p>
              </div>
            </div>

            <div className='d-flex flex-end align-items-center gap-2'>
              {loading ? (
                <Skeleton
                  width={240}
                  height={40}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <>
                  <button
                    className='billing-details-update-cta btn bg-primary text-white custom-button-property mb-0 font-size-13'
                    onClick={() => {
                      setIsActive(true)
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.UpgradeModalOpened,
                          metadata: {
                            company_id: companyId,
                            page_url: `${window.location.origin}/${window.location.pathname}?tab=billing`,
                          },
                        },
                      })
                    }}
                  >
                    {formatMessage({id: 'Update Subscription Plan'})}
                  </button>
                  <div
                    className='d-flex align-items-center position-relative border py-1 rounded'
                    style={{height: '41.65px'}}
                  >
                    <div className='dropdown-export-container'>
                      <Dropdown className='height-36'>
                        <Dropdown.Toggle className='btn btn-light table-three-dots dots-container'>
                          <img src={threeDots} alt='' className='three-dots-image' />
                        </Dropdown.Toggle>

                        <Dropdown.Menu className='m-1 rounded'>
                          <Dropdown.Item className='text-dark ps-5 rounded'>
                            <div
                              className='text-dark'
                              onClick={() => {
                                window.Intercom(
                                  'showNewMessage',
                                  'I want to cancel my subscription with subscription ID ' +
                                    billingData?.id
                                )
                              }}
                            >
                              {formatMessage({id: 'Cancel Subscription'})}
                            </div>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </>
              )}

              {/* <button
                className='billing-details-update-cta btn btn-primary mb-0 font-size-13'
                onClick={() => {
                  setIsNewActive(true)
                  TagManager.dataLayer({
                    dataLayer: {
                      event: GTMEvent.UpgradeModalOpened,
                      metadata: {
                        company_id: companyId,
                        page_url: `${window.location.origin}/${window.location.pathname}?tab=billing`,
                      },
                    },
                  })
                }}
              >
                {formatMessage({ id: 'Update Subscription Plan newone' })}
              </button> */}
            </div>
          </div>
        </div>

        {/* Payment and address section  */}
        {/* <div className='row mt-8'>
          <div className='col-md-6 h-100 mb-4 mt-4'>
            <h2 className='font-size-16 m-0'>{formatMessage({id: 'Payment Method'})}</h2>
            {loading || billingLoading ? (
              <Skeleton
                count={1}
                height={100}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='payment-billing-method bg-white p-4 mt-4 rounded-2'>
                <div className='w-100'>
                  <div className='d-flex gap-2 align-items-center'>
                    <p className='font-size-13 mb-0'>
                      {billingData?.customer?.first_name || billingData?.customer?.last_name
                        ? `${
                            toTitleCase(billingData?.customer?.first_name) +
                            ' ' +
                            toTitleCase(billingData?.customer?.last_name)
                          }`
                        : '-'}
                    </p>
                    <p className='badge badge-success px-4 py-2 mb-0'>
                      {formatMessage({id: 'Primary'})}
                    </p>
                  </div>
                  <div className='d-flex align-items-center mt-4 gap-2'>
                    <img
                      src={getPaymentMethodTypeLogo(
                        billingData?.customer?.payment_method?.type === 'card'
                          ? billingData?.card?.card_type
                          : billingData?.customer?.payment_method?.type
                      )}
                      alt='card icon'
                    />
                    <div>
                      <p className='font-size-14 m-0'>
                        {billingData?.customer?.payment_method ? (
                          billingData?.customer?.payment_method?.type === 'card' &&
                          billingData?.customer?.payment_method?.status === 'valid' ? (
                            <>
                              {`**** **** ${
                                billingData?.card?.last4
                              } ${billingData?.card?.card_type?.toUpperCase()} Card`}
                              <p className='font-size-13 text-muted m-0 mt-1'>
                                {formatMessage({id: 'Card expires on '})}
                                {billingData?.card?.expiry_month}/{billingData?.card?.expiry_year}
                              </p>
                            </>
                          ) : (
                            billingData?.customer?.payment_method?.type?.toUpperCase()
                          )
                        ) : (
                          '-'
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                <button
                  className='payment-method-cta-button btn btn-primary mb-0 font-size-13'
                  onClick={showPaymentPortalWidget}
                >
                  {formatMessage({id: 'Update'})}
                </button>
              </div>
            )}
            <div className='d-flex gap-2 align-items-center mt-4'>
              <img src={LockecIcon} alt='locked icon' />
              <p className='font-size-12 text-muted mb-0'>
                {formatMessage({id: 'Payment & Billing powered by '})}
                {billingData?.currency_code === 'INR' ? 'Razorpay' : 'Stripe'}
                {formatMessage({id: ' & Chargebee'})}
              </p>
            </div>
          </div>

          <div className='col-md-6 h-100 mb-4 mt-4'>
            <h2 className='font-size-16 m-0'>{formatMessage({id: 'Billing Address'})}</h2>
            {loading || billingLoading ? (
              <Skeleton
                count={1}
                height={100}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='payment-address-billing bg-white p-4 mt-4 rounded-2'>
                <div className='w-100'>
                  <div className='d-flex gap-2 align-items-center w-100'>
                    <p className='font-size-13 mb-0'>
                      {billingData?.customer?.billing_address
                        ? `${billingData?.customer?.billing_address?.city} ${billingData?.customer?.billing_address?.state}
                    ${billingData?.customer?.billing_address?.country}, ${billingData?.customer?.billing_address?.zip}`
                        : '-'}
                    </p>
                    <p className='badge badge-success px-4 py-2 mb-0'>
                      {formatMessage({id: 'Primary'})}
                    </p>
                  </div>
                  <div className='mt-4'>
                    <p className='font-size-13 text-muted m-0 w-75'>
                      {billingData?.customer?.billing_address
                        ? `${billingData?.customer?.billing_address?.line1} ${
                            billingData?.customer?.billing_address?.line2 || ''
                          }`
                        : '-'}
                    </p>
                  </div>
                </div>
                <button
                  className='payment-address-cta-button btn btn-primary mb-0 font-size-13'
                  onClick={() => openPortalSection(Chargebee.getPortalSections().ADDRESS)}
                >
                  {formatMessage({id: 'Update'})}
                </button>
              </div>
            )}
          </div>
        </div> */}

        <div className='row mt-8'>
          <div className='col-md-6 h-100 mb-4 mt-4'>
            <h2 className='font-size-16 m-0'>{formatMessage({id: 'Payment Method'})}</h2>
            {loading ? (
              <>
                <div className='payment-billing-method bg-white p-4 mt-4 rounded-2'>
                  <div className='w-100'>
                    <div className='d-flex gap-2 align-items-center'>
                      <Skeleton
                        width={180}
                        height={20}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                    </div>
                    <div className='d-flex align-items-center mt-4 gap-2'>
                      <Skeleton
                        width={40}
                        height={40}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                      <div>
                        <Skeleton
                          width={300}
                          height={40}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className='payment-billing-method bg-white p-4 mt-4 rounded-2'>
                <div className='w-100'>
                  <div className='d-flex gap-2 align-items-center'>
                    <p className='font-size-13 mb-0'>
                      {billingData?.customer?.first_name || billingData?.customer?.last_name
                        ? `${
                            toTitleCase(billingData?.customer?.first_name) +
                            ' ' +
                            toTitleCase(billingData?.customer?.last_name)
                          }`
                        : '-'}
                    </p>
                    <p className='badge badge-success px-4 py-2 mb-0'>
                      {formatMessage({id: 'Primary'})}
                    </p>
                  </div>
                  <div className='d-flex align-items-center mt-4 gap-2'>
                    <img
                      src={getPaymentMethodTypeLogo(
                        billingData?.customer?.payment_method?.type === 'card'
                          ? billingData?.card?.card_type
                          : billingData?.customer?.payment_method?.type
                      )}
                      alt='card icon'
                    />
                    <div>
                      <p className='font-size-14 m-0'>
                        {billingData?.customer?.payment_method ? (
                          billingData?.customer?.payment_method?.type === 'card' &&
                          billingData?.customer?.payment_method?.status === 'valid' ? (
                            <>
                              {`**** **** ${
                                billingData?.card?.last4
                              } ${billingData?.card?.card_type?.toUpperCase()} Card`}
                              <p className='font-size-13 text-muted m-0 mt-1'>
                                {formatMessage({id: 'Card expires on '})}
                                {billingData?.card?.expiry_month}/{billingData?.card?.expiry_year}
                              </p>
                            </>
                          ) : (
                            billingData?.customer?.payment_method?.type?.toUpperCase()
                          )
                        ) : (
                          '-'
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                <button
                  className='payment-method-cta-button btn bg-primary text-white custom-button-property mb-0 font-size-13'
                  onClick={showPaymentPortalWidget}
                >
                  {formatMessage({id: 'Update'})}
                </button>
              </div>
            )}
            <div className='d-flex gap-2 align-items-center mt-4'>
              <img src={LockecIcon} alt='locked icon' />
              <p className='font-size-12 text-muted mb-0'>
                {formatMessage({id: 'Payment & Billing powered by '})}
                {billingData?.currency_code === 'INR' ? 'Razorpay' : 'Stripe'}
                {formatMessage({id: ' & Chargebee'})}
              </p>
            </div>
          </div>

          <div className='col-md-6 h-100 mb-4 mt-4'>
            <h2 className='font-size-16 m-0'>{formatMessage({id: 'Billing Address'})}</h2>
            {loading ? (
              <div className='payment-billing-method bg-white p-4 mt-4 rounded-2'>
                <div className='w-100'>
                  <div className='d-flex gap-2 align-items-center'>
                    <Skeleton
                      width={180}
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='d-flex align-items-center mt-4 gap-2'>
                    <Skeleton
                      width={40}
                      height={40}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                    <div>
                      <Skeleton
                        width={300}
                        height={40}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className='payment-address-billing bg-white p-4 mt-4 rounded-2'>
                <div className='w-100'>
                  <div className='d-flex gap-2 align-items-center w-100'>
                    <p className='font-size-13 mb-0'>
                      {billingData?.customer?.billing_address?.city
                        ? `${billingData?.customer?.billing_address?.city} ${billingData?.customer?.billing_address?.state}
                ${billingData?.customer?.billing_address?.country}, ${billingData?.customer?.billing_address?.zip}`
                        : '-'}
                    </p>
                    <p className='badge badge-success px-4 py-2 mb-0'>
                      {formatMessage({id: 'Primary'})}
                    </p>
                  </div>
                  <div className='mt-4'>
                    <p className='font-size-13 text-muted m-0 w-75'>
                      {billingData?.customer?.billing_address?.line1
                        ? `${billingData?.customer?.billing_address?.line1} ${
                            billingData?.customer?.billing_address?.line2 || ''
                          }`
                        : '-'}
                    </p>
                  </div>
                </div>
                <button
                  className='payment-address-cta-button btn bg-primary text-white custom-button-property mb-0 font-size-13'
                  onClick={() => openPortalSection(Chargebee.getPortalSections().ADDRESS)}
                >
                  {formatMessage({id: 'Update'})}
                </button>
              </div>
            )}
          </div>
        </div>

        {/* invoice Table  */}
        <div className='mt-8 w-100 mb-4'>
          <div className='d-flex align-items-center justify-content-between'>
            <h2 className='font-size-16 m-0'>
              {formatMessage({id: 'Billing History & Invoices'})}
            </h2>
            <form className=' align-items-center d-flex'>
              <span className='svg-icon svg-icon-3 position-absolute ms-3'>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                  className='mh-50px'
                >
                  <rect
                    opacity='0.5'
                    x='17.0365'
                    y='15.1223'
                    width='8.15546'
                    height='2'
                    rx='1'
                    transform='rotate(45 17.0365 15.1223)'
                    fill='currentColor'
                  ></rect>
                  <path
                    d='M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z'
                    fill='currentColor'
                  ></path>
                </svg>
              </span>
              <input
                type='text'
                className='bg-body form-control form-control-flush ps-10 height-36px rounded font-weight-400 text-clrA1'
                name='search'
                placeholder={formatMessage({id: 'Search Invoices'})}
                data-kt-search-element='input'
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </form>
          </div>
          <>
            <div className='table table-responsive bg-white rounded-2 p-4 mt-4 mb-4'>
              {loading ? (
                <>
                  <Table className='w-100'>
                    <thead className='custom-thead border-bottom'>
                      <tr className='font-size-12 font-weight-400 table-row border-dark-mode'>
                        <th className='min-w-220px pb-6 pt-4'>
                          {formatMessage({id: 'Billing Date'})}
                        </th>
                        <th className='min-w-220px pb-6 pt-4'>
                          {formatMessage({id: 'Invoice ID'})}
                        </th>
                        <th className='min-w-220px pb-6 pt-4'>
                          {formatMessage({id: 'Invoice Amount'})}
                        </th>
                        <th className='min-w-220px pb-6 pt-4'>{formatMessage({id: 'Status'})}</th>
                        <th className='min-w-220px pb-6 pt-4'>{formatMessage({id: 'Actions'})}</th>
                      </tr>
                    </thead>
                    <tbody className='w-100'>
                      <tr>
                        <td colSpan={5} className='pt-4'>
                          <div className='w-100'>
                            <Skeleton
                              width={'100%'}
                              height={40}
                              className='mb-2'
                              baseColor='var(--kt-skeleton-bg-color)'
                              highlightColor='var(--kt-skeleton-highlight-bg-color)'
                              count={10}
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </>
              ) : (
                <Table className='w-100'>
                  <thead
                    className={`custom-thead border-bottom ${
                      paginatedInvoices.length === 0 ? 'd-none' : ''
                    }`}
                  >
                    <tr className='font-size-12 font-weight-400 table-row border-dark-mode'>
                      <th className='min-w-220px pb-6 pt-4'>
                        {formatMessage({id: 'Billing Date'})}
                      </th>
                      <th className='min-w-220px pb-6 pt-4'>{formatMessage({id: 'Invoice ID'})}</th>
                      <th className='min-w-220px pb-6 pt-4'>
                        {formatMessage({id: 'Invoice Amount'})}
                      </th>
                      <th className='min-w-220px pb-6 pt-4'>{formatMessage({id: 'Status'})}</th>
                      <th className='min-w-220px pb-6 pt-4'>{formatMessage({id: 'Actions'})}</th>
                    </tr>
                  </thead>

                  {paginatedInvoices.length === 0 ? (
                    <tbody className='w-100'>
                      <tr>
                        <td colSpan={5} className='pt-4'>
                          <NoDataPage />
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody className='w-100'>
                      {paginatedInvoices.map((invoice: any) => (
                        <tr key={invoice?.id} className='border-bottom'>
                          <td className='pt-4'>
                            <div> {invoice?.billingDate}</div>
                          </td>
                          <td className='pt-4'>
                            <div>{invoice?.invoiceId}</div>
                          </td>
                          <td className='pt-4'>
                            <div>{`${invoice?.currency} ${invoice?.amount}`}</div>
                          </td>
                          <td className='pt-3'>
                            {
                              <div className='d-flex gap-4 align-items-center'>
                                <div
                                  className={`badge badge-${invoice?.statusBadge} px-4 py-2 w-100px text-center d-block`}
                                >
                                  {formatMessage({id: toTitleCase(invoice?.status)})}
                                </div>
                                <div className=''>
                                  {invoice?.status === 'payment_due' && (
                                    <div
                                      className={`d-flex gap-1 align-items-center ${
                                        isLoading ? '' : 'cursor-pointer'
                                      }`}
                                      onClick={!isLoading ? collectDuePayments : undefined}
                                    >
                                      <img
                                        src={toAbsoluteUrl(
                                          '/media/icons/duotune/general/ic-retry.svg'
                                        )}
                                        alt='Retry'
                                      />
                                      <p className='mb-0 text-danger w-100px'>
                                        {isLoading
                                          ? 'Please wait...'
                                          : formatMessage({id: 'Retry'})}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            }
                          </td>

                          <td className='pt-3'>
                            {/* Actions button or dropdown */}
                            {
                              <button
                                onClick={() => downloadInvoice(invoice.invoiceId)}
                                disabled={downloadingStatus[invoice?.invoiceId]}
                                className='bg-transparent text-primary p-0 m-0 border-0'
                              >
                                {' '}
                                <img src={Downloadicon} alt='download icon' />
                                {downloadingStatus[invoice.invoiceId]
                                  ? formatMessage({id: 'Downloading...'})
                                  : formatMessage({id: 'Download'})}
                              </button>
                            }
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              )}
            </div>
          </>

          <div
            className={
              paginatedInvoices.length === 0
                ? 'd-none'
                : 'w-100 d-flex justify-content-between align-items-center px-0 mt-8'
            }
          >
            <div className='d-flex gap-2 w-100 align-items-center'>
              <Form.Select
                aria-label='Default select example'
                className='px-4 py-3 w-80px'
                onChange={handleItemsPerPageChange}
                value={itemsPerPage}
              >
                <option value='10'>{formatMessage({id: '10'})}</option>
                <option value='20'>{formatMessage({id: '20'})}</option>
                <option value='50'>{formatMessage({id: '50'})}</option>
                <option value='100'>{formatMessage({id: '100'})}</option>
              </Form.Select>
              <span className='font-size-13'>
                {formatMessage({id: 'Showing '})} {(currentPage - 1) * itemsPerPage + 1}
                {formatMessage({id: ' to '})}{' '}
                {Math.min(currentPage * itemsPerPage, invoices.length)}
                {formatMessage({id: ' of '})} {invoices.length} {formatMessage({id: ' records'})}
              </span>
            </div>
            <Pagination className='w-100 d-flex flex-end'>
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                &lt;
              </Pagination.Prev>
              {pages}
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === pageCount}
              >
                &gt;
              </Pagination.Next>
            </Pagination>
          </div>
        </div>
      </div>

      <Modal
        show={showUpdateAddressInfoModal}
        onHide={() => setShowUpdateAddressInfoModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{formatMessage({id: 'Billing Address is required'})}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {formatMessage({
              id: 'You need to update billing address before adding any payment method.',
            })}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='primary' onClick={handleShowUpdateAddressInfoModal}>
            {formatMessage({id: 'OK'})}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showIframeModal}
        onHide={() => setShowIframeModal(false)}
        aria-labelledby='contained-modal-title-vcenter'
        centered
        backdropClassName='sub-modal-2'
        className='sub-modal-2'
      >
        <Modal.Body>
          <iframe title='Add Credits' src={urlData} width='100%' height={600}></iframe>
        </Modal.Body>
      </Modal>
      <BillingModalRK
        modalShow={isActive}
        setModalShow={setIsActive}
        currentState={currentState}
        setCurrentState={setCurrentState}
        selected={selected}
        setSelected={setSelected}
        currencyBill={currencyBill}
        changePlan={(plan: string) => changePlan(plan)}
        localBilling={localBilling}
        setlocalBilling={setlocalBilling}
        localPlan={localPlan}
        setlocalPlan={setlocalPlan}
        billingModalLoading={billingModalLoading}
        setBillingModalLoading={setBillingModalLoading}
      />
      {/* <UpdateBillingModal
        modalShow={isActive}
        setModalShow={setIsActive}
        currencyBill={currencyBill}
        localBilling={localBilling}
        setlocalBilling={setlocalBilling}
        currentState={currentState}
        setCurrentState={setCurrentState}
        selected={selected}
        setSelected={setSelected}
        changePlan={changePlan}
        localPlan={localPlan}
        setlocalPlan={setlocalPlan}
        billingModalLoading={billingModalLoading}
        setBillingModalLoading={setBillingModalLoading}
      />  */}
    </>
  )
}
